// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"29bc63e4","374":"3336d900","453":"025ef4bb","484":"0b1741d6"}[chunkId] + ".chunk.js";
};